import BannerCarousel from '@/components/BannerCarousel'
import LiveBar from '@/components/LiveBar'
import MessageBox from '@/components/MessageBox'
import NewsPreview from '@/components/NewsPreview'
import ScheduleAndPromo from '@/components/ScheduleAndPromo'
import SiteFooter from '@/components/SiteFooter'
import SiteHeader from '@/components/SiteHeader'
import TeamCarousel from '@/components/TeamCarousel'
import { useNews } from '@/hooks/useNews'
import { useNewsBanners } from '@/hooks/useNewsBanners'
import { useRadioData } from '@/hooks/useRadioData'
import { getOnAirMember } from '@/lib/time'
import { useHead } from '@unhead/react'
import { Link } from 'react-router-dom'

function Home() {
  const { settings, team, banners, social, partners, loading, error } = useRadioData()
  const { articles, loading: newsLoading } = useNews(true)
  const { banners: newsBanners } = useNewsBanners()
  const current = getOnAirMember(team)
  const title = settings?.seoTitle || `${settings?.stationName || 'Bonita FM'} ${settings?.frequency || '87,9'} — ${settings?.slogan || 'A rádio da nossa gente'}`
  const description = settings?.seoDescription || `${settings?.description || 'Ouça a rádio ao vivo.'} Horário: ${settings?.hours || '24 horas no ar'}.`

  useHead({
    title,
    htmlAttrs: { lang: 'pt-BR' },
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { name: 'theme-color', content: '#0b2ea8' },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-title', content: settings?.stationName || 'Bonita FM' },
    ],
    link: [
      { rel: 'manifest', href: '/manifest.json' },
      { rel: 'apple-touch-icon', href: settings?.iconUrl || 'https://static.lumi.new/1c/1c03124dcceef146bc23161bc9ba4a67.png' },
    ],
  })

  if (loading) {
    return (
      <div className="radio-bg min-h-screen">
        <SiteHeader settings={settings} social={social} />
        <main className="mx-auto max-w-7xl space-y-10 px-3 py-6 sm:px-4 lg:px-6">
          <div className="h-28 animate-pulse rounded-[28px] bg-white/10 sm:h-32" />
          <div className="aspect-[3/1] animate-pulse rounded-[22px] bg-white/10" />
          <NewsPreview articles={[]} loading />
        </main>
      </div>
    )
  }

  return (
    <div className="radio-bg min-h-screen">
      <SiteHeader settings={settings} social={social} />
      <main className="pt-5">
        {error ? <p className="mb-4 text-center text-sm text-amber-200">{error}</p> : null}
        <LiveBar settings={settings} current={current} />
        <BannerCarousel banners={banners} rotation={settings?.bannerRotation} />
        <MessageBox />
        <NewsPreview articles={articles} loading={newsLoading} newsBanners={newsBanners} />
        <TeamCarousel team={team} />
        <ScheduleAndPromo team={team} settings={settings} social={social} partners={partners} />
      </main>
      <SiteFooter settings={settings} />
      <Link
        to="/admin"
        className="fixed bottom-4 right-4 rounded-full bg-black/30 px-3 py-1 text-[10px] font-bold tracking-wide text-white/60 hover:text-white"
      >
        ADMIN
      </Link>
    </div>
  )
}

export default Home
